import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  currentUser: {},
  token: "",
  avatar: "",
  subscriptionStatus: false,
  freePlan: false,
  remainingDays: 0,
  isLocationSwitched:false,
};

const authenticationSlice = createSlice({
  name: "authenticationValues",
  initialState,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.currentUser = action.payload.user;
      action.payload.token &&
        localStorage.setItem("token", action.payload.token);
      action.payload.avatar &&
        localStorage.setItem("avatar", action.payload.avatar);
      state.token = action.payload.token ? action.payload.token : state.token;
      state.avatar = action.payload.avatar;
      state.subscriptionStatus = action.payload.subscriptionStatus? action.payload.subscriptionStatus: state.subscriptionStatus;
      if (action.payload.avatar === null) {
        localStorage.setItem("avatar", "");
      }
    },
    freePlan(state, action) {
      state.freePlan = action.payload.free;
      state.remainingDays = action.payload.remainingDays;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.subscriptionStatus = false;
      state.freePlan = false;
      state.token = "";
      state.avatar = "";
      state.currentUser = {};
      const preserveLanguage = localStorage.getItem("i18nextLng");
      localStorage.clear();
      if (preserveLanguage) {
        localStorage.setItem("i18nextLng", preserveLanguage);
      }
    },
    switchLocation(state,action){
      state.isLocationSwitched = !state.isLocationSwitched;
    },
    setCurrentLocation(state, action) {
      // Expect action.payload to contain:
      const { currentLocation, currentLocationId } = action.payload || {};
      // Only update the specific fields; keep everything else intact
      if (currentLocation !== undefined) {
        state.currentUser = {
          ...state.currentUser,
          currentLocation: currentLocation,
        };
        if (currentLocation) {
          localStorage.setItem("currentLocation", currentLocation);
        } else {
          localStorage.removeItem("currentLocation");
        }
      }

      if (currentLocationId !== undefined) {
        state.currentUser = {
          ...state.currentUser,
          currentLocationId: currentLocationId,
        };
        if (currentLocationId) {
          localStorage.setItem("currentLocationId", currentLocationId);
        } else {
          localStorage.removeItem("currentLocationId");
        }
      }
      if (currentLocationId === undefined || currentLocation === undefined) {
        state.currentUser = {
          ...state.currentUser,
          currentLocationId: null,
          currentLocation: null,
        };
        localStorage.removeItem("currentLocation");
        localStorage.removeItem("currentLocationId");
      }
    },
    updateConsent(state, action) {
      const payload = action.payload || {};
      const termsAccepted =
        payload.termsAccepted !== undefined
          ? !!payload.termsAccepted
          : !!state.currentUser?.consent?.termsAccepted;
      const privacyPolicyAccepted =
        payload.privacyPolicyAccepted !== undefined
          ? !!payload.privacyPolicyAccepted
          : !!state.currentUser?.consent?.privacyPolicyAccepted;
      const requiresConsent =
        payload.requiresConsent !== undefined
          ? !!payload.requiresConsent
          : !(termsAccepted && privacyPolicyAccepted);

      state.currentUser = {
        ...state.currentUser,
        consent: {
          ...(state.currentUser.consent || {}),
          ...payload,
          termsAccepted,
          privacyPolicyAccepted,
          requiresConsent,
        },
      };
    },
  },
});

export const {
  login,
  logout,
  freePlan,
  setCurrentLocation,
  switchLocation,
  updateConsent,
} = authenticationSlice.actions;
export default authenticationSlice.reducer;
